import { ReactComponent as EmptyIcon } from 'app/assets/img/icon_empty_data.svg';
import React, { memo } from 'react';
import { objectType } from 'types';
interface EmptyBlockProps {
  translations: objectType | undefined;
}
const EmptyBlock = ({ translations }: EmptyBlockProps) => (
  <>
    <div className="d-flex justify-content-center pt-5">
      <EmptyIcon />
    </div>
    <div
      className="d-flex justify-content-center mt-2"
      style={{ marginBottom: 30 }}
    >
      {translations?.['b2b.txt.MSG001'] || ''}
    </div>
  </>
);
export default memo(EmptyBlock);
